<template>
    <div>
        <breadCrumb 
            :icon="'fa-gifts'"
            :category="$t(`sideNav.navSalonMenu`)"
            :subCategory="$t(`subMenu.salon_menu_reward`)"
            :subSubCategory="''">
        </breadCrumb>
        <div v-if="!addRewardToggle" class="text-right mt-3 mr-5">
            <button class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" title="Add New Product" @click="addRewardToggle = !addRewardToggle">
                <span class="fal fa-plus mr-2"></span>
                <span>{{$t('button_link.add') + $t(`subMenu.salon_menu_reward`)}}</span>
            </button>
        </div>
        <addReward v-if="addRewardToggle" @returnRewardList="returnRewardList"></addReward>
        <rewardList ref="rewardList" v-else></rewardList>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import RewardList from './Reward_List'
import AddReward from './Reward_Add'
export default {
    name: "menuReward",
    components: {
        RewardList, AddReward, BreadCrumb
    },
    data(){
        return{
            addRewardToggle: false, 
            isModalShow: false, isError: false, message: "",
            rewardListKey: 0
        }
    },
    methods:{
        returnRewardList(){
            this.addRewardToggle = false;
        },
    },
}
</script>
<style scoped>
.show{
    display: block;
}
</style>